// The HiiKER preset avatars offered on the signup photo step.
//
// These are the same 17 illustrations the mobile apps show (iOS ships them in
// Assets.xcassets/profile_pics; Android as vector drawables), copied here as
// PNGs so web offers the identical set rather than a different-looking one.
//
// Picking one sends its absolute URL as `updateUser(avatar:)`, the existing
// remote-URL flow — AttachAvatarWorker fetches and attaches it server-side.
// A photo the user uploads themselves goes through the direct-upload path and
// `avatarKey` instead; both end up as the same ActiveStorage attachment.

// @ts-ignore — resolved by Vite, stubbed by Jest's asset mapper
import backpack from '../../images/profile_pics/profile_backpack.png';
// @ts-ignore
import boot from '../../images/profile_pics/profile_boot.png';
// @ts-ignore
import camper from '../../images/profile_pics/profile_camper.png';
// @ts-ignore
import campfire from '../../images/profile_pics/profile_campfire.png';
// @ts-ignore
import compass from '../../images/profile_pics/profile_compass.png';
// @ts-ignore
import deer from '../../images/profile_pics/profile_deer.png';
// @ts-ignore
import discovery from '../../images/profile_pics/profile_discovery.png';
// @ts-ignore
import hiker from '../../images/profile_pics/profile_hiker.png';
// @ts-ignore
import lotus from '../../images/profile_pics/profile_lotus.png';
// @ts-ignore
import map from '../../images/profile_pics/profile_map.png';
// @ts-ignore
import mountain from '../../images/profile_pics/profile_mountain.png';
// @ts-ignore
import pizza from '../../images/profile_pics/profile_pizza.png';
// @ts-ignore
import planets from '../../images/profile_pics/profile_planets.png';
// @ts-ignore
import tent from '../../images/profile_pics/profile_tent.png';
// @ts-ignore
import trail from '../../images/profile_pics/profile_trail.png';
// @ts-ignore
import trailRunners from '../../images/profile_pics/profile_trail_runners.png';
// @ts-ignore
import waymarkers from '../../images/profile_pics/profile_waymarkers.png';

export interface PresetAvatar {
  /** Stable id, used as the selection key and for the accessible name. */
  id: string;
  /** Bundled asset path. Relative, so it needs resolving before it is sent. */
  src: string;
}

export const PRESET_AVATARS: ReadonlyArray<PresetAvatar> = Object.freeze([
  { id: 'hiker', src: hiker },
  { id: 'map', src: map },
  { id: 'compass', src: compass },
  { id: 'mountain', src: mountain },
  { id: 'trail', src: trail },
  { id: 'boot', src: boot },
  { id: 'waymarkers', src: waymarkers },
  { id: 'discovery', src: discovery },
  { id: 'backpack', src: backpack },
  { id: 'tent', src: tent },
  { id: 'campfire', src: campfire },
  { id: 'trail_runners', src: trailRunners },
  { id: 'camper', src: camper },
  { id: 'deer', src: deer },
  { id: 'planets', src: planets },
  { id: 'pizza', src: pizza },
  { id: 'lotus', src: lotus },
]);

/**
 * The server fetches the avatar by URL, so a bundled asset path has to be made
 * absolute before it is sent — a relative "/vite/assets/..." means nothing to
 * the worker doing the fetching.
 */
export const absoluteAvatarUrl = (src: string, origin?: string): string => {
  if (!src) return '';
  if (/^https?:\/\//i.test(src)) return src;
  const base = origin || (typeof window !== 'undefined' ? window.location.origin : '');
  return `${base}${src.startsWith('/') ? '' : '/'}${src}`;
};

/** Humanised name for the accessible label ("trail_runners" → "Trail runners"). */
export const avatarLabel = (id: string): string => {
  if (!id) return '';
  const words = id.replace(/_/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};
